export default __webpack_public_path__ + "static/media/wall.575a7d21.png";